import script from "./AccountLogout.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountLogout.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__